export const formatNumber = (number: number | string | null | undefined) => {
  const numberFormatter = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2 });
  return numberFormatter.format(Number(number));
};
